import React, { useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Bridging, BridgeConfirmation, BridgeProcess } from '../../components';
import { TokenContext, ABIContext } from '../../components/Context';
import { useHistory, useParams } from 'react-router-dom';
import { approve, deposit } from '../../bridging';
import { Web3Context } from '../../web3/Web3Context';
import { EthNetworkInfo, BinanceNetworkInfo } from '../../services/networkServices';
import { toBN } from 'web3-utils';
// import styles from './Bridge.module.scss';
import axios from 'axios';

const CHAIN_ID = parseInt(process.env.REACT_APP_CHAIN_ID);

const Bridge = () => {
    const { t } = useTranslation();
    const params = useParams();
    const { nftType } = params;
    const [bridgeConfirm, setBridgeConfirm] = useState(false);
    const [chestType, setChestType] = useState("gold");
    const [chests, setChests] = useState(0);

    const [tickets, setTickets] = useState(0);
    const [ticketType, setTicketType] = useState("gold");
    const [bridgedTickets, setBridgedTickets] = useState([]);

    const [skinCount, setSkinCount] = useState(0);
    const [skinType, setSkinType] = useState("bardMale");
    const [bridgedSkins, setBridgedSkins] = useState([]);

    const [confirm, setConfirm] = useState('');
    const [state] = useContext(TokenContext);
    const [abiConfig] = useContext(ABIContext);
    const [maxChest, setMaxChest] = useState(0);
    const [maxTicket, setMaxTicket] = useState(0); // only signifies max number of a particular ticket type i.e. for either gold or silver or bronze, but not total
    const [maxSkinCount, setMaxSkinCount] = useState(0); // only signifies the max number of skin for a particular skin type i.e. for either bardMale or bardFemale, but not total
    const history = useHistory();
    const { selectedAccount, networkId, switchNetwork, web3 } = useContext(Web3Context);
    
    const [txnHash, setTxnHash] = useState("");
    const [mintTxnHash, setMintTxnHash] = useState('');

    const [approveFlag, setApproveFlag] = useState(false);
    const [submitProcessing, setSubmitProcessing] = useState(false);

    const WALLET_BRIDGING_STATUS_URL = `${process.env.REACT_APP_BACKEND_API}/bridging/${selectedAccount}`;

    const { ethereumDeploymentContext } = abiConfig;

    const ws = useRef(null);

    const checkTransactionCompletion = (userAccount, rootToken, depositAmount, txhash) => {
        const childChainManagerProxy = process.env.REACT_APP_CHILD_CHAIN_MANAGER_PROXY;
        const abiCoder = web3.eth.abi;

        if (CHAIN_ID === 1) {
            ws.current = new WebSocket("wss://ws-mainnet.matic.network/");
        } else {
            ws.current =  new WebSocket("wss://ws-mumbai.matic.today/");
        }

        ws.current.onopen = () => {
            ws.current.send(
                `{"id": 1, "method": "eth_subscribe", "params": ["newDeposits", {"Contract": "${childChainManagerProxy}"}]}`
            );

            ws.current.onmessage = (msg) => {
                const parsedMsg = JSON.parse(msg.data);

                if (
                    parsedMsg &&
                    parsedMsg.params &&
                    parsedMsg.params.result &&
                    parsedMsg.params.result.Data
                ) {
                    const fullData = parsedMsg.params.result.Data;
                    const { 0: syncType, 1: syncData } = abiCoder.decodeParameters(
                        ["bytes32", "bytes"],
                        fullData
                    );

                    // check if sync is of deposit type (keccak256("DEPOSIT"))
                    const depositType = "0x87a7811f4bfedea3d341ad165680ae306b01aaeacc205d227629cf157dd9f821";
                    if (syncType.toLowerCase() === depositType.toLowerCase()) {
                        const {
                            0: userAddress,
                            1: rootTokenAddress,
                            2: depositData,
                        } = abiCoder.decodeParameters(
                            ["address", "address", "bytes"],
                            syncData
                        );

                        const { 0: amount } = abiCoder.decodeParameters(
                            ["uint256"],
                            depositData
                        );

                        if (
                            userAddress.toLowerCase() === userAccount.toLowerCase() &&
                            rootToken.toLowerCase() === rootTokenAddress.toLowerCase() &&
                            depositAmount === amount &&
                            parsedMsg.params.result.TxHash === txhash
                        ) {
                            setConfirm('deposit-success');
                            ws.current.close();
                        }
                    } 
                }
            }

            ws.current.onerror = () => {
                console.log("Error");
            };
        
            ws.current.onclose = () => {
                console.log("Close");
            };
        };
    }

    // helper function to compare two arrays
    const areEqual = (array1, array2) => {
        if (array1.length === array2.length) {
          return array1.every(element => {
            if (array2.includes(element)) {
              return true;
            }
      
            return false;
          });
        }
        return false;
    }

    useEffect(() => {
        // setting variables for when bridging of chest is attempted
        if (state.bridgeChest?.name && state.chestBalance.goerli[state.bridgeChest.name]) {
            setChestType(state.bridgeChest.name);
            setMaxChest(state.chestBalance.goerli[state.bridgeChest.name]);
        }

        // add an else if condition for bridging of tickets
        if(state.bridgingTicketType !== '' && state.bridgingTicketType !== undefined) {
            setTicketType(state.bridgingTicketType);
            const maxBalanceForSelectedTicket = state.ticketBalance.bsc[state.bridgingTicketType].count;
            setMaxTicket(maxBalanceForSelectedTicket);
        }

        // add an else if condition for bridging of skins
        if(state.bridgingSkinType !== '' && state.bridgingSkinType !== undefined) {
            setSkinType(state.bridgingSkinType);
            const maxBalanceForSelectedSkin = state.skinBalance.bsc[state.bridgingSkinType].count;
            setMaxSkinCount(maxBalanceForSelectedSkin);
        }
        
        if (!state.bridgeChest?.name && !state.bridgingTicketType && !state.bridgingSkinType) {
            history.push('/inventory/chests');
        }
    }, [state]);

    useEffect(() => {
        try {
            let mintedTokens = [];
            let mintedTxnHash = '';
            if(confirm === 'awaiting-mint') {
                console.log({confirm, tickets, skinCount, bridgedTickets, bridgedSkins });
    
                if(((bridgedTickets.length > 0) && (tickets == bridgedTickets.length)) || ((bridgedSkins.length > 0) && (skinCount == bridgedSkins.length))) {
                    setInterval(async () => {
                        const rawResult = await axios.get(WALLET_BRIDGING_STATUS_URL).catch(err => { console.log(err)});
                        if(rawResult.status === 200) {
                            const res = rawResult.data;
                            if(res.status === 'minted') {
                                const tokens = res.tokens;
                                const slicedTokens = tokens.slice(0, (tickets || skinCount));

                                slicedTokens.forEach(token => {
                                    if(token['token_status'] === 'minted') {
                                        mintedTokens.push(token['receiver_token_id']);
                                        mintedTxnHash = token['minted_txnhash']
                                    }
                                });

                                if(areEqual(mintedTokens, bridgedTickets) || areEqual(mintedTokens, bridgedSkins)) {
                                    setConfirm('deposit-success');
                                    if(mintedTxnHash !== '') {
                                        setMintTxnHash(mintedTxnHash);
                                    }
                                }
                            }

                            if(res.status === 'failed') {
                                setConfirm('failed')
                            }
                        }
                        
                    }, 10000);
                }
            }
        } catch(e) {
            console.log(`Error: ${e}`);
        }
    }, [confirm, tickets, skinCount, bridgedTickets, bridgedSkins]);

    const bridgeToPolygon = async () => {
        try {
            let chestsWeiCount = chests * 1e18;
            if (chests) {
                let tokenContract = ethereumDeploymentContext.contracts[state.bridgeChest.tokenContractName];
                await approve(tokenContract.address, chestsWeiCount.toString(), selectedAccount, setConfirm, web3, setApproveFlag, approveFlag, setSubmitProcessing);
                const {txhash, chestConfig} = await deposit(tokenContract.address, chestsWeiCount.toString(), selectedAccount, web3, setConfirm);
                setTxnHash(txhash);
                checkTransactionCompletion(selectedAccount, chestConfig, chestsWeiCount.toString(), txhash);
                setChests(0);
              }
        } catch (e) {
            console.log(e);
            setConfirm('canceled');
            setSubmitProcessing(false);
        }
    }

    // TODO: Create a function that approve the bridging and initiates transfer on the bridged network
    const bridgeTicketToPolygon = async () => {
        const { 
            skinAndTicket: {
                ticketContract,
                ticketAddress,
                nftReceiverContract,
                nftReceiverAddress,
            }
        } = abiConfig;

        let ticketIdsToBeBridged = [];
        
        try {
            if(tickets) {
                // populate ticketIdsToBeBridged array with values from tokens
                for(let i = 0; i < tickets; i++) {
                    ticketIdsToBeBridged.push(state.ticketBalance.bsc[ticketType].tokens[i]);
                }
                setBridgedTickets(ticketIdsToBeBridged);

                // display processing modal even before metamask approval
                setConfirm('waitingapproval');
                setApproveFlag(false);

                let gasPrice = await web3.eth.getGasPrice();
                let gasPriceBN = toBN(gasPrice);
                let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.1 * gasPriceBN))).toString();
                let gasEstimate = await ticketContract.methods.setApprovalForAll(nftReceiverAddress, true).estimateGas({from: selectedAccount});

                let approvalTxnResult = await ticketContract.methods.setApprovalForAll(nftReceiverAddress, true).send({
                    from: selectedAccount,
                    gasLimit: gasEstimate,
                    gasPrice: finalGasPrice
                });

                if(approvalTxnResult.status === true && approvalTxnResult.transactionHash) {
                    setConfirm('deposit');
                    setApproveFlag(true);

                    gasEstimate = await nftReceiverContract.methods.transferToken(ticketAddress, ticketIdsToBeBridged).estimateGas({from: selectedAccount});

                    let txnTransferResult = await nftReceiverContract.methods.transferToken(ticketAddress, ticketIdsToBeBridged).send({
                        from: selectedAccount,
                        gasLimit: gasEstimate,
                        gasPrice: finalGasPrice
                    });

                    if(txnTransferResult.status === true && txnTransferResult.transactionHash) {
                        setTxnHash(txnTransferResult.transactionHash);
                        setConfirm('awaiting-mint');
                    }
                }
            }

        } catch (e) {
            console.log("Error: ", e);
            // generic error handling code. all errors, not cancelled by user, are labeled as failed
            if(e.code !== 4001) {
                setConfirm('failed');
            } else {
                setConfirm('canceled');
            }
            setSubmitProcessing(false);
        }
    }

    const bridgeSkinToPolygon = async () => {
        // we require both skin and ticket contract because of Special Edition Skins 
        // under the ticket contract
        const {
            skinAndTicket: {
                ticketContract,
                ticketAddress,
                skinContract,
                skinAddress,
                nftReceiverContract,
                nftReceiverAddress
            }
        } = abiConfig;

        let skinIdsToBeBridged = [];

        try {
            if(skinCount) {
                // populate skinIdsToBeBridged array with values from tokens
                for(let i = 0; i < skinCount; i++) {
                    skinIdsToBeBridged.push(state.skinBalance.bsc[skinType].tokens[i]);
                }
                setBridgedSkins(skinIdsToBeBridged);

                // display processing modal even before metamask approval
                setConfirm('waitingapproval');
                setApproveFlag(false);

                // special edition skins minted under Ticket contract
                if (skinType === 'soulHarvester' || skinType === 'phantomQueen') {
                    // gas price estimation
                    let gasPrice = await web3.eth.getGasPrice();
                    let gasPriceBN = toBN(gasPrice);
                    let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.1 * gasPriceBN))).toString();
                    let gasEstimate = await ticketContract.methods.setApprovalForAll(nftReceiverAddress, true).estimateGas({from: selectedAccount});

                    let sesApprovalTxnResult = await ticketContract.methods.setApprovalForAll(nftReceiverAddress, true).send({
                        from: selectedAccount,
                        gasLimit: gasEstimate,
                        gasPrice: finalGasPrice
                    });

                    if(sesApprovalTxnResult.status === true && sesApprovalTxnResult.transactionHash) {
                        setConfirm('deposit');
                        setApproveFlag(true);

                        gasEstimate = await nftReceiverContract.methods.transferToken(ticketAddress, skinIdsToBeBridged).estimateGas({from: selectedAccount});
                        
                        // initate txn to transfer special edition skins to NFT receiver contract
                        let sesTxnTransferResult = await nftReceiverContract.methods.transferToken(ticketAddress, skinIdsToBeBridged).send({
                            from: selectedAccount,
                            gasLimit: gasEstimate,
                            gasPrice: finalGasPrice
                        });

                        if(sesTxnTransferResult.status === true && sesTxnTransferResult.transactionHash) {
                            setTxnHash(sesTxnTransferResult.transactionHash);
                            setConfirm('awaiting-mint');
                        }
                    }
                } else {
                    let gasPrice = await web3.eth.getGasPrice();
                    let gasPriceBN = toBN(gasPrice);
                    let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.1 * gasPriceBN))).toString();
                    let gasEstimate = await skinContract.methods.setApprovalForAll(nftReceiverAddress, true).estimateGas({from: selectedAccount});

                    let skinApprovalTxnResult = await skinContract.methods.setApprovalForAll(nftReceiverAddress, true).send({
                        from: selectedAccount,
                        gasLimit: gasEstimate,
                        gasPrice: finalGasPrice
                    });

                    if(skinApprovalTxnResult.status === true && skinApprovalTxnResult.transactionHash) {
                        setConfirm('deposit');
                        setApproveFlag(true);
                        
                        gasEstimate = await nftReceiverContract.methods.transferToken(skinAddress, skinIdsToBeBridged).estimateGas({from: selectedAccount});

                        let skinTxnTransferResult = await nftReceiverContract.methods.transferToken(skinAddress, skinIdsToBeBridged).send({
                            from: selectedAccount,
                            gasLimit: gasEstimate,
                            gasPrice: finalGasPrice
                        });

                        if(skinTxnTransferResult.status === true && skinTxnTransferResult.transactionHash) {
                            setTxnHash(skinTxnTransferResult.transactionHash);
                            setConfirm('awaiting-mint');
                        }
                    }
                }
            }
        } catch(e) {
            console.log(`Error is: ${e}`);
            if(e.code !== 4001) {
                setConfirm('failed');
            } else {
                setConfirm('canceled');
            }
            setSubmitProcessing(false);
        }
    }

    const renderBridgingContent = (bridgeType) => {
        if(bridgeType === 'chests') {
            return (
                <>
                    <Bridging
                        chestType={chestType}
                        setBridgeConfirm={setBridgeConfirm}
                        chests={chests}
                        setChests={setChests}
                        maxChest={maxChest}
                        switchNetwork={switchNetwork}
                        networkId={networkId}
                        NetInfo={EthNetworkInfo}
                        submitProcessing={submitProcessing}
                    />
                    <BridgeConfirmation
                        bridgeConfirm={bridgeConfirm}
                        setBridgeConfirm={setBridgeConfirm}
                        chestType={chestType}
                        chests={chests}
                        bridgeToPolygon={bridgeToPolygon}
                    />
                    <BridgeProcess 
                        confirm={confirm}
                        setConfirm={setConfirm}
                        setBridgeConfirm={setBridgeConfirm}
                        chests={chests}
                        chestType={chestType}
                        txnHash={txnHash}
                    />
                </>
            );
        }
        else if(bridgeType === 'tickets') {
            return (
                <>
                    <Bridging
                        setBridgeConfirm={setBridgeConfirm}
                        tickets={tickets}
                        ticketType={ticketType}
                        setTickets={setTickets}
                        maxTicket={maxTicket}
                        switchNetwork={switchNetwork}
                        networkId={networkId}
                        NetInfo={BinanceNetworkInfo}
                        submitProcessing={submitProcessing}
                    />
                    <BridgeConfirmation
                        bridgeConfirm={bridgeConfirm}
                        setBridgeConfirm={setBridgeConfirm}
                        tickets={tickets}
                        ticketType={ticketType}
                        bridgeTicketToPolygon={bridgeTicketToPolygon}
                    />
                    <BridgeProcess 
                        confirm={confirm}
                        setConfirm={setConfirm}
                        setBridgeConfirm={setBridgeConfirm}
                        tickets={tickets}
                        ticketType={ticketType}
                        txnHash={txnHash}
                        mintTxnHash={mintTxnHash}
                    />
                </>
            );
        }
        else if(bridgeType === 'skins') {
            return (
                <>
                    <Bridging
                        setBridgeConfirm={setBridgeConfirm}
                        skinCount={skinCount}
                        skinType={skinType}
                        setSkinCount={setSkinCount}
                        maxSkinCount={maxSkinCount}
                        switchNetwork={switchNetwork}
                        networkId={networkId}
                        NetInfo={BinanceNetworkInfo}
                        submitProcessing={submitProcessing}
                    />
                    <BridgeConfirmation
                        bridgeConfirm={bridgeConfirm}
                        setBridgeConfirm={setBridgeConfirm}
                        skinCount={skinCount}
                        skinType={skinType}
                        bridgeSkinToPolygon={bridgeSkinToPolygon}
                    />
                    <BridgeProcess 
                        confirm={confirm}
                        setConfirm={setConfirm}
                        setBridgeConfirm={setBridgeConfirm}
                        skinCount={skinCount}
                        skinType={skinType}
                        txnHash={txnHash}
                        mintTxnHash={mintTxnHash}
                    />
                </>
            )
        }
    } 

    return (
        <>
            { renderBridgingContent(nftType) }
        </>
    )
}

export { Bridge };